module.exports = __webpack_public_path__ + "static/media/03-text.9b6682af.png";